module.exports = __webpack_public_path__ + "Icono_NuevoRegistro_256px.png";